<!-- <canvas id="migrationChart"></canvas> -->
<div *ngIf="data && data.length > 0; else noData">
  <canvas #genreChart></canvas>
</div>

<ng-template #noData>
  <div class="w-full h-full min-h-[260px] flex items-center justify-center">
    <div
      class="flex flex-col items-center justify-center text-center bg-gray-50 rounded-xl border border-dashed border-gray-300 px-6 py-8"
    >
      <!-- Icône -->
      <div class="bg-blue-100 text-blue-500 p-4 rounded-full mb-3">
        <i class="pi pi-chart-pie text-2xl"></i>
      </div>

      <!-- Texte -->
      <p class="text-gray-600 font-medium text-sm">Aucune donnée disponible</p>

      <p class="text-gray-400 text-xs mt-1">
        Les statistiques ne sont pas disponibles pour cette cohorte.
      </p>
    </div>
  </div>
</ng-template>
